import { Switch } from 'react-router-dom'
import { ProtectedRoute } from 'components/ProtectedRoute'
import Organizations from './components/Organizations'
import { CIMSPage, Permission } from '@cims-online/shared'
import ResponseDisciplines from './components/ResponseDisciplines'
import RFITracker from './components/RFITracker'
import RFIQuickLinks from './components/RFIQuickLinks'
import Notifications from './components/Notifications'

const RequestsForInformation: React.FC = () => (
  <Switch>
    <ProtectedRoute
      path={CIMSPage.RFITracker.projectPath}
      permissions={[
        Permission.ViewRequestForInformation,
        Permission.EditRFIResponse,
      ]}
    >
      <RFITracker />
    </ProtectedRoute>
    <ProtectedRoute
      path={CIMSPage.RFIOrganizations.projectPath}
      permissions={Permission.ViewRFIOrganization}
    >
      <Organizations />
    </ProtectedRoute>
    <ProtectedRoute
      path={CIMSPage.RFIResponseDisciplines.projectPath}
      permissions={Permission.ViewRFIResponseDiscipline}
    >
      <ResponseDisciplines />
    </ProtectedRoute>
    <ProtectedRoute
      path={CIMSPage.RFIQuickLinks.projectPath}
      permissions={Permission.ViewRFIQuickLink}
    >
      <RFIQuickLinks />
    </ProtectedRoute>
    <ProtectedRoute
      path={CIMSPage.RFINotifications.projectPath}
      permissions={Permission.ViewRFINotification}
    >
      <Notifications />
    </ProtectedRoute>
  </Switch>
)

export default RequestsForInformation
